module.exports = "<p>\n  sign-in works!\n</p>\n"